module.exports = __webpack_public_path__ + "images/banners/item_top/item_top_banner_btn-hover_8b8121b8659563d124be1a4fbae74a5a.png";